<template>
    <div>
        {{$t('book')}}
        <drop-menu-button :title="selectedDN" :options="options" :value="selectedDN" @menu="selectScope"
        menuname="Address book list" @hide="buttonSelected = false" @show="buttonSelected = true" size="auto">
            <template v-slot:icon>
                <b-button tabindex="-1" variant="primary">{{selectedName}}
                    <font-awesome-icon icon="chevron-down"
                            :class="{ buttonSelected: buttonSelected }"></font-awesome-icon>
                </b-button>
            </template>
            <template v-slot:row="{ row }">
                <div v-if="row.header" class="scopeOwnerTitle">
                    {{row.header}}
                </div>
                <div :style="{ paddingLeft: `${row.indent}px` }">{{row.text}}</div>
            </template>
        </drop-menu-button>

        <new-addr-entry v-if="rights >= 5" :scope="selectedDN" @newEntry="selectDN"></new-addr-entry>

        <new-addr-book v-if="this.$store.state.settings.enterprise" :scopes="scopes"
                @newScope="selectScope"></new-addr-book>
        <b-button v-if="canDelete" @click="doDelete">
            {{$t('deleteBook')}}
        </b-button>
        <b-button v-if="canShare">
            {{$t('shareBook')}}
        </b-button>

    </div>
</template>

<script>
import DropMenuButton from '@/components/DropMenuButton';
import NewAddrBook from '@/components/newAddrBook';
import NewAddrEntry from '@/components/newAddrEntry';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'addressBookList',
  components: { DropMenuButton, NewAddrBook, NewAddrEntry, FontAwesomeIcon },
  i18nOptions: { keyPrefix: 'addresses' },
  data: function() {
    return {
      indentWidth: 10,
      buttonSelected: false
    };
  },
  props: {
    selectedDN: String,
    scopes: Array
  },
  methods: {
    selectScope(dn) {
      let scope = this.scopes.find(s => s.dn === dn);
      if (scope) {
        if (scope.standard) {
          if (scope.name === 'personal') {}
          this.$router.push({ name: 'addressBook', params: { book: scope.name } });
        } else {
          this.$router.push({ name: 'addressBookPersonal', params: { owner: scope.owner, folder: scope.name } });
        }
      }
    },
    selectDN(dn) {
      this.$emit('selectDN', dn);
    },
    doDelete() {
      this.$dialog.confirm(this.$t('confirmDelete', { name: this.selectedName }),
        { okText: this.$t('general:buttons.yes'), cancelText: this.$t('general:buttons.no') })
        .then(() => {
          this.$store.dispatch('deleteAddrBook', { dn: this.selectedDN })
            .then(() => {
              this.$router.push({ name: 'addressBook', params: { book: 'personal' } });
            })
            .catch(e => {
              this.$dialog.alert(this.$t('deleteAddrBookError', { error: e.message }));
            });
        });
    },
    getLeftMargin(row) {
      let indent = 0;
      if (row.standard) {
        const indents = { internal: 1, users: 2, lists: 2, external: 1, global: 2, personal: 2 };
        indent = indents[row.name] || 0;
      } else {
        indent = 3;
      }
      return indent * 10;
    },
    isFirstOfUser(row) {
      if (row.standard) {
        return false;
      }
      const ind = this.scopes.findIndex(s => s.id === row.id);
      return (this.scopes[ind - 1].ownerid !== row.ownerid);
    },
    getDisplayName(row) {
      if (row.standard) {
        return row.displayName;
      }
      return row.name;
    }
  },
  computed: {
    thisScope() {
      return this.scopes.find(s => s.dn === this.selectedDN);
    },
    options() {
      return this.scopes.map(s => {
        let o = { text: this.getDisplayName(s), value: s.dn, indent: this.getLeftMargin(s) };
        if (this.isFirstOfUser(s)) {
          o.header = s.owner;
        }
        return o;
      });
    },
    selectedId() {
      if (this.thisScope) {
        return this.thisScope.id.toString();
      } else {
        return '-';
      }
    },
    selectedName() {
      if (this.thisScope) {
        return this.thisScope.displayName;
      } else {
        return `--${this.selectedDN}`;
      }
    },
    rights() {
      if (this.thisScope) {
        return this.thisScope.rights;
      } else {
        return 0;
      }
    },
    canDelete() {
      const scope = this.thisScope;
      if (!scope) {
        return false;
      }
      if (!this.$store.state.settings.enterprise || scope.standard) {
        return false;
      }
      return (scope.owner.localeCompare(this.$store.state.username, 'en', { sensitivity: 'base' }) === 0);
    },
    canShare() {
      const scope = this.thisScope;
      if (!scope) {
        return false;
      }
      if (!this.$store.state.settings.enterprise || scope.standard || (scope.rights < 9)) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    button {
        margin-left: 0.3em;
        svg {
            transition: transform 0.2s;
            &.buttonSelected {
                transform: rotate(-180deg);
            }
        }

    }
    div.dropMenuButton .ib_wrap {
        padding: 0;
    }

    .scopeOwnerTitle {
        font-weight: bold;
        background-color: $dark;
        color: $light;
        padding: 0 5px;
        margin: -5px -5px 0 -5px;
    }
</style>
